import { render } from "./PAPSIMobileLoginView.vue?vue&type=template&id=a442a44c&scoped=true"
import script from "./PAPSIMobileLoginView.vue?vue&type=script&lang=js"
export * from "./PAPSIMobileLoginView.vue?vue&type=script&lang=js"

import "./PAPSIMobileLoginView.vue?vue&type=style&index=0&id=a442a44c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a442a44c"]])

export default __exports__